import { configureStore, combineReducers } from "@reduxjs/toolkit";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import authReducer from "./authSlice";

const persistConfig = {
  key: "autobet_root",
  version: 1,
  storage,
  whitelist: ["auth"],
};

const rootReducer = combineReducers({
  auth: authReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);

export const getStoredAccessToken = () => {
  try {
    const fromState = store.getState()?.auth?.accessToken;
    if (fromState && fromState !== "undefined" && fromState !== "null") {
      return fromState;
    }
    const persistedRoot = localStorage.getItem("persist:autobet_root");
    if (persistedRoot) {
      const parsed = JSON.parse(persistedRoot);
      if (parsed.auth) {
        const auth = JSON.parse(parsed.auth);
        if (
          auth.accessToken &&
          auth.accessToken !== "undefined" &&
          auth.accessToken !== "null"
        ) {
          return auth.accessToken;
        }
      }
    }
    const legacy =
      localStorage.getItem("accessToken") || localStorage.getItem("token");
    if (legacy && legacy !== "undefined" && legacy !== "null") {
      return legacy;
    }
  } catch {
    // Ignore restricted storage errors
  }
  return "";
};
